import { Button } from 'primereact/button';

interface TourHelpButtonProps {
  onClick: () => void;
}

export const TourHelpButton = ({ onClick }: TourHelpButtonProps) => {
  return (
    <Button
      icon="pi pi-question-circle"
      severity="secondary"
      text
      rounded
      size="small"
      onClick={onClick}
      tooltip="Page tour"
      tooltipOptions={{ position: 'left' }}
      className="flex-shrink-0"
    />
  );
};
